export default {
  API_ENDPOINT: `https://glacial-atoll-73669.herokuapp.com/api/bookmarks`,
  API_TOKEN: process.env.api_token,
}